import { DeleteForever } from "@mui/icons-material"
import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from "@mui/material"
import api from "api/client";
import { Send, Upload } from "lucide-react";
import { useSnackbar } from "providers/SnackbarProvider";
import { memo, useState } from "react"
import { useNavigate } from "react-router-dom";

const FeedbackRemarksDialog = ({
    openRemarksDialog,
    handleSubmitFeedback,
    setOpenRemarksDialog,
    loading,
}) => {
    const navigate = useNavigate()
    const { showSnackbar } = useSnackbar();

    const [remarks, setRemarks] = useState("")

    const handleRemarksChange = (e) => {
        const value = e.target.value
        setRemarks(value)
    }

    const handleSubmit = async () => {
        try {
            await handleSubmitFeedback(remarks)
        } catch (err) {

        } finally {
            setRemarks("")
        }
    }

    return (
        <Dialog
            open={openRemarksDialog}
            onClose={() => setOpenRemarksDialog(false)}
            maxWidth="xs"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: 3,
                    p: 1,
                },
            }}
        >
            <DialogTitle
                sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1.5,
                    fontSize: "18px",
                    fontWeight: 600,
                    pb: 1,
                }}
            >
                <Box
                    sx={{
                        width: 42,
                        height: 42,
                        borderRadius: "50%",
                        backgroundColor: "rgb(232, 243, 253)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <Upload
                        style={{
                            color: "rgb(86, 167, 253)",
                            fontSize: 24,
                        }}
                    />
                </Box>

                Submit Feedback
            </DialogTitle>

            <DialogContent sx={{ pt: 1 }}>
                <Typography
                    sx={{
                        fontSize: "14px",
                        color: "#666",
                        lineHeight: 1.6,
                    }}
                >
                    Please provide comments prior to submission
                </Typography>

                <Box sx={{ mt: 1.5 }}>
                    <Typography sx={{ fontSize: '14px', fontWeight: 'bold' }}>
                        Remarks
                        <span style={{ color: "red" }}>
                            *
                        </span>
                    </Typography>
                    <TextField
                        value={remarks}
                        onChange={handleRemarksChange}
                        multiline
                        fullWidth
                        placeholder="Enter your comments"
                        minRows={2}
                        maxRows={3}
                        sx={{
                            "&. MuiInputBase-input": {
                                fontSize: '12px'
                            },
                            "& .MuiOutlinedInput-root": {
                                borderRadius: "10px",
                            },

                            "& .MuiInputBase-input": {
                                fontSize: "14px",
                            },

                            "& .MuiInputBase-input::placeholder": {
                                fontSize: "14px",
                                opacity: 1,
                                color: '#a2a2a2'
                            },
                            mt: 0.5
                        }}
                    />
                </Box>
            </DialogContent>

            <DialogActions
                sx={{
                    px: 2,
                    pb: 2,
                    gap: 1,
                }}
            >
                <Button
                    onClick={() => setOpenRemarksDialog(false)}
                    variant="outlined"
                    disabled={loading}
                    sx={{
                        textTransform: "none",
                        borderRadius: 2,
                        px: 2.5,
                        color: "#555",
                        borderColor: "#DADADA",
                        "&:hover": {
                            borderColor: "#BDBDBD",
                            backgroundColor: "#F8F8F8",
                        },
                    }}
                >
                    Close
                </Button>

                <Button
                    onClick={handleSubmit}
                    variant="contained"
                    startIcon={
                        loading ? (
                            <CircularProgress
                                size={18}
                                sx={{ color: "#a2a2a2" }}
                            />
                        ) : (
                            <Upload size={15} />
                        )
                    }
                    sx={{
                        textTransform: "none",
                        borderRadius: 2,
                        px: 2.5,
                        backgroundColor: "rgb(86, 167, 253)",
                        boxShadow: "none",
                        "&:hover": {
                            backgroundColor: "rgb(59, 117, 179)",
                            boxShadow: "none",
                        },
                    }}
                    disabled={loading}
                >
                    {loading ? "Submitting..." : "Submit"}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default memo(FeedbackRemarksDialog)